'use strict';

var security = angular.module('security', ['resources']);

security.constant('ResolverCodes', {
  isAuthenticated: '401a',
  notAuthenticated: '401',
  forbidden: '403',
  notFound: '404',
});

security.factory('CurrentUser', function($q, UserResource, ResolverCodes, $location, ClinicConfig) {
  function CurrentUser() {
    var user;
    var self = this;

    this.isAuthenticated = function() {
      if (!user) {
        return;
      }
      return user.authenticated;
    };
    this.isImpersonated = function() {
      return !!_.get(user, 'impersonated');
    };
    this.isImpersonatedInProd = function() {
      return self.isImpersonated() && ClinicConfig.ENV === 'production';
    };
    this.getCompany = function() {
      if (!user || !user.editable || !user.editable.companies || !user.editable.companies.length) {
        return;
      }
      return user.editable.companies[0];
    };
    this.getClinics = function() {
      if (!user || !user.editable) {
        return;
      }
      return user.editable.clinics;
    };
    this.getDoctors = function() {
      if (!user || !user.editable) {
        return;
      }
      return user.editable.doctors;
    };
    this.getUserId = function() {
      if (!user) {
        return;
      }
      return user.id;
    };
    this.isPatient = function() {
      if (!user || !user.editable) {
        return;
      }
      return user.editable.patients && user.editable.patients.length;
    };
    this.getUser = function() {
      return user;
    };
    this.isPartnerUser = function() {
      return !!user.partner;
    };

    // Returns a promise
    this.hasPermission = function(modelType, modelId) {
      var deferred = $q.defer();

      $q.when(user.$promise).then(function() {
        if (!user.authenticated) {
          return deferred.reject(ResolverCodes.notAuthenticated);
        }
        if (user.superuser) {
          return deferred.resolve();
        }

        for (var i = 0; i < user.permissions.length; i++) {
          var permission = user.permissions[i];
          if (modelType == permission.modelType && modelId == permission.modelId) {
            return deferred.resolve();
          }
        }
        deferred.reject(ResolverCodes.forbidden);
      });

      return deferred.promise;
    };

    this.hasPermissionNonPromise = function(modelType, modelId) {
      if (!user || !user.permissions) {
        return false;
      }
      if (user.superuser) {
        return true;
      }

      for (var i = 0; i < user.permissions.length; i++) {
        var permission = user.permissions[i];
        if (modelType == permission.modelType && modelId == permission.modelId) {
          return true;
        }
      }
      return false;
    };

    this.hasOwnerPermission = function() {
      if (!user) {
        return;
      }
      return !!_.findWhere(user.permissions, {
        permissionType: 'O',
      });
    };

    // Returns a promise that will wait for the user to load.
    // Once the user has loaded, the promise will resolve to the return
    // value of the passed in callback.
    this.waitForUserLoad = function(callback) {
      var deferred = $q.defer();
      var nextUrl = encodeURIComponent($location.path());

      $q.when(user.$promise)
        .then(() => {
          if (!user.superuser && self.isPatient()) {
            return $location.path('/user/type/').search('nextUrl', nextUrl);
          }
          deferred.resolve(callback ? callback() : null);
        })
        .catch(() => {
          deferred.reject();
        });

      return deferred.promise;
    };

    this.getAllOnlineBookingDoctors = function(clinicId) {
      const doctorIds = this.getClinics()
        ?.map((clinic) => clinic.providers)
        .flat()
        .filter((provider) => provider.onlineBooking && provider.clinic === clinicId)
        .map((provider) => provider.doctor) ?? [];

      return this.getDoctors()
        ?.filter((doctor) => doctorIds.includes(doctor.id));
    };

    this.update = function(callback) {
      callback = callback || function() {};
      user = UserResource.get({
        deep: true,
      }, callback);
    };

    this.updateAsync = () =>
      new Promise((resolve, reject) => {
        try {
          this.update(resolve);
        } catch (error) {
          reject(error);
        }
      });

    this.update();
  }

  return new CurrentUser();
});

security.provider('authorization', function() {
  this.requireAuthorizedUser = ['authorization', function(authorization) {
    return authorization._requireAuthorizedUser();
  }];
  this.requireUnauthorizedUser = ['authorization', function(authorization) {
    return authorization._requireUnauthorizedUser();
  }];

  this.$get = function($q, CurrentUser, ResolverCodes, ClinicConfig, $window) {
    return {
      _requireAuthorizedUser: function() {
        var deferred = $q.defer();

        CurrentUser.waitForUserLoad(CurrentUser.isAuthenticated)
          .then((authenticated) => {
            if (authenticated) {
              if (CurrentUser.isPartnerUser()) {
                $window.location.href = ClinicConfig.SEARCH_APP_V2_URL + '/partner';
                return null;
              }
              deferred.resolve();
            } else {
              deferred.reject(ResolverCodes.notAuthenticated);
            }
          })
          .catch(() => {
            deferred.reject(ResolverCodes.notAuthenticated);
          });

        return deferred.promise;
      },
      _requireUnauthorizedUser: function() {
        var deferred = $q.defer();

        CurrentUser.waitForUserLoad(CurrentUser.isAuthenticated)
          .then((authenticated) => {
            if (authenticated) {
              deferred.reject(ResolverCodes.isAuthenticated);
            } else {
              deferred.resolve();
            }
          })
          .catch(() => {
            deferred.reject(ResolverCodes.isAuthenticated);
          });

        return deferred.promise;
      },
    };
  };
});
